import type { NodeConfigurationContextTemplatable } from '@onefootprint/request-types/dashboard';
import type { TemplateInputProps } from '@onefootprint/ui';

/** Map the API token shape onto what Form.Template* / Monaco expect. */
export const toAutocompleteItems = (
  autocomplete: NodeConfigurationContextTemplatable['autocomplete'] | undefined,
): TemplateInputProps['autocompleteItems'] =>
  Object.entries(autocomplete ?? {}).reduce(
    (acc, [key, value]) => {
      acc[key === 'workflowContextKeys' ? 'others' : key] = value.map(item => ({
        label: item.display,
        value: item.token,
        detail: item.dataType.join(' | '),
      }));
      return acc;
    },
    {} as TemplateInputProps['autocompleteItems'],
  );
